import { CommonModule, NgTemplateOutlet } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core'
import { environment } from '../../../../environments/environment'
import { ImageComponent } from '../../../abacus/elements/partials/image/image.component'
import { EmptyPlaceHolderPipe } from '../../../abacus/pipes/empty-placeholder.pipe'
import { getOrder } from '../../../resources/policy-initiative/policy-initiative-detail/utils/policy-initiative-step-definition-view.function'
import { policyInitiativeSteps } from '../../../resources/policy-initiative/policy-initiative.definition'
import { PolicyInitiativeView } from './models/policy-initiative-view.model'

@Component({
  selector: 'app-policy-initiative-view',
  templateUrl: './policy-initiative-view.component.html',
  styleUrls: ['./policy-initiative-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    NgTemplateOutlet,
    EmptyPlaceHolderPipe,
    ImageComponent
  ]
})
export class PolicyInitiativeViewComponent {
  protected readonly PolicyInitiativeSteps = policyInitiativeSteps
  protected readonly storagePath = environment.storagePath
  protected policyInitiativeViewDefinition =
    input.required<PolicyInitiativeView[]>()

  protected itemsByStep = computed(() => {
    return {
      step1: this.policyInitiativeViewDefinition()
        .filter((item) => item.step === 1)
        .sort((a, b) => getOrder(a.key, 1) - getOrder(b.key, 1)),
      step2: this.policyInitiativeViewDefinition().filter(
        (item) => item.step === 2
      ),
      step3: this.policyInitiativeViewDefinition().filter(
        (item) => item.step === 3
      )
    }
  })
}
